var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigBeanVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 913,
    viewBox: "0 0 1728 913",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M723.411 81.2122C633.523 19.6039 520.428 -11.4295 399.598 3.85792C191.509 30.1523 25.0386 197.549 1.52229 403.624C-29.8844 679.409 187.641 913 460.554 913H1257.17C1498.06 913 1706.61 735.055 1727.65 497.947C1751.79 227.207 1536.58 0.0360728 1267.53 0.0360728C1171.15 0.0360728 1081.57 29.2351 1007.62 79.225C921.288 137.47 809.122 140.069 723.256 81.2122H723.411Z",
    fill: "#FFCA2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBeanVector);
export default __webpack_public_path__ + "static/media/BigBeanVector.af780d966024736ef3daa29d0b98c892.svg";
export { ForwardRef as ReactComponent };